import angular from 'angular'
import Invoice from '../../fillOpenManage/invoice1/standModel/Invoice'

class redInkConfirmFormDetailCtrl {
    constructor($scope, httpRequest, globalFn, logger, $state, $stateParams,sweetalert) {
        $scope.dictData = {}
        const types = ['red_confirm_work_status','red_confirm_status','red_confirm_open_status','red_confirm_red_reason','vat_usage_code','excise_usage_code','entry_status']
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.ukeyList = JSON.parse(localStorage.getItem('user_info')).tax4UkeyList
        if($stateParams.ukeyId && $stateParams.ukeyId === $scope.ukeyList[0].ukeyId){
            $scope.ukeyId = $stateParams.ukeyId
        }else {
            $scope.ukeyId = $scope.ukeyList[0].ukeyId
        }
        $scope.invoiceList = []
        $scope.startNum = 1
        $scope.totalNum = $stateParams.total
        $scope.type = $stateParams.type
        $scope.selectBillIndex = 0;
        httpRequest.post_getListRedConfirmBody({confirmIds:$stateParams.confirmIds.split(',')}).then((res) => {
            $scope.invoiceList = res.data.value
            $scope.invoiceListShow =  $scope.invoiceList[$scope.selectBillIndex]
            // console.log($scope.invoiceListShow)
            totalCalculation($scope.invoiceListShow.ovatTax4RedConfirmDetails)
        })

        $scope.prevInv = function () {
            if ($scope.selectBillIndex === 0) return;
            $scope.selectBillIndex--;
            $scope.startNum--;
            $scope.invoiceListShow = $scope.invoiceList[$scope.selectBillIndex];
            totalCalculation($scope.invoiceListShow.ovatTax4RedConfirmDetails)
        };
        $scope.nextInv = function () {
            if ($scope.selectBillIndex === $scope.totalNum - 1) return;
            $scope.selectBillIndex++;
            $scope.startNum++;
            $scope.invoiceListShow = $scope.invoiceList[$scope.selectBillIndex];
            totalCalculation($scope.invoiceListShow.ovatTax4RedConfirmDetails)
        };

        // 更新 合计 金额 税额
        function totalCalculation(billList) {
            $scope.totalAmount = 0
            $scope.totalTaxAmount = 0
            $scope.totalAdValoremTotal = 0
            angular.forEach(billList, (item, index) => {
                $scope.totalAmount = globalFn.Add($scope.totalAmount, item.amount)
                $scope.totalTaxAmount = globalFn.Add($scope.totalTaxAmount, item.taxAmount)
                $scope.totalAdValoremTotal = globalFn.Add($scope.totalAmount, $scope.totalTaxAmount)
            })
            $scope.chineseAmtTotal = globalFn.digitUppercase($scope.totalAdValoremTotal)
        }
        // 返回
        $scope.returnList = function returnList() {
            $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.list')
        }
        // 拒绝 / 全部拒绝
        $scope.refuseBtn = function refuseBtn() {
            console.log('拒绝 / 全部拒绝')
            let data = []
            angular.forEach($scope.invoiceList, (item, index) => {
                data.push({
                    confirmId: item.confirmId,
                    confirmType: 'N',//confirmType (string, optional): 确认类型 Y 同意； N 拒绝 ,
                    ukeyId:$scope.ukeyId,
                    uuid:item.uuid,
                })
            })
            if($scope.type == '2'){
                httpRequest.post_batchConfirmOrRejectRedConfirm(data).then((res) => {
                    const value = res.data.value
                    logger.logSuccess(`拒绝操作成功${value.successNum}条，拒绝操作失败${value.failNum}条。`)
                    $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.list')
                })
            }else {
                let param = {
                    confirmId: $scope.invoiceList[0].confirmId,
                    confirmType: 'N',//confirmType (string, optional): 确认类型 Y 同意； N 拒绝 ,
                    ukeyId:$scope.ukeyId,
                    uuid:$scope.invoiceList[0].uuid,
                }
                httpRequest.post_confirmOrRejectRedConfirm(param).then((res) => {
                    logger.logSuccess(`当前红字确认单拒绝操作成功，拒绝后不可开票。`)
                })
                $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.list')
            }

        }
        // 确认 / 全部确认
        $scope.confirmBtn = function confirmBtn() {
            console.log('确认 / 全部确认')
            let ukeyList = $scope.ukeyList.filter(u => {
                return u.ukeyId == $scope.ukeyId;
            });
            //确认单状态 确认即开票标识为Y
            let confirmApplyFlag = false
            if($scope.invoiceList.some((ele) => ele.confirmApplyFlag === 'Y')){
                confirmApplyFlag = true
            }
            //确认单状态 为“无需确认/购方录入待销方确认/销方录入待购方确认”
            let confirmStatus = false
            if($scope.invoiceList.some((ele) => (ele.confirmStatus == '01' || ele.confirmStatus == '02' || ele.confirmStatus == '03'))){
                confirmStatus = true
            }
            if(ukeyList[0].manageType === '6' || confirmApplyFlag || confirmStatus){
                sweetalert.confirm('温馨提示', '您所选择的确认单中，部分确认单在上传税局申请成功后，将直接生成红字发票，请确定是否继续提交?').then(() => {
                    realConfirmBtn()
                })
            }else {
                realConfirmBtn()
            }
        }
        function realConfirmBtn() {
            let data = []
            angular.forEach($scope.invoiceList, (item, index) => {
                data.push({
                    confirmId: item.confirmId,
                    confirmType: 'Y',//confirmType (string, optional): 确认类型 Y 同意； N 拒绝 ,
                    ukeyId:$scope.ukeyId,
                    uuid:item.uuid,
                })
            })
            if($scope.type == '2') {
                httpRequest.post_batchConfirmOrRejectRedConfirm(data)
                    .then((res) => {
                        const value = res.data.value
                        logger.logSuccess(`确认操作成功${value.successNum}条，确认操作失败${value.failNum}条。`)
                        $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.list')
                    })
            }else {
                let param = {
                    confirmId: $scope.invoiceList[0].confirmId,
                    confirmType: 'Y',//confirmType (string, optional): 确认类型 Y 同意； N 拒绝 ,
                    ukeyId:$scope.ukeyId,
                    uuid:$scope.invoiceList[0].uuid,
                }
                httpRequest.post_confirmOrRejectRedConfirm(param).then((res) => {})
                $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.list')
            }
        }
    }
}

redInkConfirmFormDetailCtrl.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', '$state', '$stateParams', 'sweetalert']
export default redInkConfirmFormDetailCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/confirmCtrl.js